import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { Popover, PopoverModule } from 'primeng/popover';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

import { MediaFolderFormCommonComponent } from '../../../../../../ui/media-album-form-common/src/lib/form/media-folder-form-common/media-folder-form-common-component';
import {
  deleteMediaItemFromAlbum,
  deleteSelectedFolderFromStorage,
} from '../../../store/media-gallery.actions';
import { FilePropertiesFormComponent } from '../file-properties-form/file-properties-form.component';
import { FolderTreeComponent } from '../folder-tree/folder-tree.component';

@Component({
  selector: 'offconon-list-menu-item',
  templateUrl: './list-menu-item.component.html',
  styles: ``,
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule,
    ButtonModule,
    MenuModule,
    TableModule,
    SelectButtonModule,
    PopoverModule,
    MatIcon,
    ConfirmDialogModule,
    FolderTreeComponent,
    DialogModule,
    FilePropertiesFormComponent,
    MediaFolderFormCommonComponent,
  ],
})
export class ListMenuItemComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() folderList: any;
  @Input() saveWithCrop = false;
  @Input() currentFolder: any;
  @Output() selectedItemEmit = new EventEmitter<any>();
  @Output() selectedFolderIdEmit = new EventEmitter<any>();
  @Output() selectedFolderEmit = new EventEmitter<any>();
  @Output() EditImageEmit = new EventEmitter<any>();
  @Output() editedFolderEmit = new EventEmitter<any>();
  @Output() deleteFolderEmit = new EventEmitter<any>();
  @Output() deletedIdEmit = new EventEmitter<any>();
  @ViewChildren(Popover)
  popovers: QueryList<Popover>;
  menuItems: MenuItem[];
  folderMenuItems: MenuItem[];
  selectFolder = false;
  copyAction = false;
  editProperty = false;
  editFolder = false;
  private translateService = inject(TranslateService);
  private store = inject(Store);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);

  ngOnChanges(): void {
    this.renderMenu(this.data);
    this.renderFolderMenu(this.data);
  }
  ngOnInit(): void {
    this.renderMenu(this.data);
    this.renderFolderMenu(this.data);
  }

  renderFolderMenu(data: any) {
    this.folderMenuItems = [
      {
        label: this.translateService.instant('Manage'),
        visible: data,
        items: [
          {
            label: this.translateService.instant('Edit Folder'),
            icon: 'edit',
            visible: data,
            command: () => {
              this.editFolders();
            },
          },
          {
            label: this.translateService.instant('Move'),
            icon: 'send',
            visible: data,
            command: () => {
              this.copyAction = false;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Delete'),
            icon: 'delete',
            icon_color: 'text-red-500',
            visible: data,
            command: () => {
              this.deleteFolder();
            },
          },
        ],
      },
    ];
  }

  renderMenu(data: any) {
    this.menuItems = [
      {
        label: this.translateService.instant('Manage'),
        visible: data,
        items: [
          {
            label: this.translateService.instant('Edit image'),
            icon: 'edit',
            visible: data.media_file_type === 'image' && !this.saveWithCrop,
            command: () => {
              this.editImage(data);
            },
          },
          {
            label: this.translateService.instant('File properties'),
            icon: 'edit',
            visible: data,
            command: () => {
              this.editProperties(data);
            },
          },
          {
            label: this.translateService.instant('Play video'),
            icon: 'play_arrow',
            visible: data.media_file_type === 'video',
            command: () => {
              this.openNewTab();
            },
          },
          {
            label: this.translateService.instant('Open in new tab'),
            icon: 'open_in_new',
            visible: data.media_file_type === 'video' || data.media_file_type === 'image',
            command: () => {
              this.openNewTab();
            },
          },
          {
            label: this.translateService.instant('Open/Download'),
            icon: 'open_in_new',
            visible:
              data.media_file_type === 'document' ||
              data.media_file_type === 'zip' ||
              data.media_file_type === 'other',
            command: () => {
              this.openNewTab();
            },
          },
          {
            label: this.translateService.instant('Download'),
            icon: 'download',
            visible: data,
            command: () => {
              this.downloadFile();
            },
          },
          {
            label: this.translateService.instant('Move'),
            icon: 'send',
            visible: data,
            command: () => {
              this.copyAction = false;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Copy'),
            icon: 'file_copy',
            visible: data,
            command: () => {
              this.copyAction = true;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Delete'),
            icon: 'delete',
            icon_color: 'text-red-500',
            visible: data,
            command: () => {
              this.deleteMedia();
            },
          },
        ],
      },
    ];
  }
  togglePopover(event: any, id: any) {
    const popover = this.popovers
      .toArray()
      .find((popover: Popover) => popover.el.nativeElement.id === String(id));

    if (popover) {
      this.popovers.toArray().forEach((p: Popover) => {
        if (p !== popover) {
          p.hide();
        }
      });

      popover.toggle(event);
    }
  }
  toggleImagePopover(event: any, id: any) {
    const popover = this.popovers
      .toArray()
      .find((popover: Popover) => popover.el.nativeElement.id === String(id));

    if (popover) {
      this.popovers.toArray().forEach((p: Popover) => {
        if (p !== popover) {
          p.hide();
        }
      });

      popover.toggle(event);
    }
  }

  deleteFolder() {
    if (this.data) {
      let media_id: number = this.data.id;
      this.confirmationService.confirm({
        message: this.translateService.instant('Are you sure you want to delete this?'),
        header: this.translateService.instant('Attention'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.store.dispatch(deleteSelectedFolderFromStorage({ id: media_id }));
          setTimeout(() => {
            this.deleteFolderEmit.emit(media_id);
          }, 200);

          this.messageService.add({
            severity: 'info',
            summary: this.translateService.instant('Successful'),
            detail: this.translateService.instant('Your request has been successfully completed.'),
          });
        },
        key: 'deletefolder-' + this.data.id,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('Error'),
        detail: this.translateService.instant('No selected item found!'),
      });
    }
  }

  editFolders() {
    this.editFolder = true;
  }
  onlyCloseEditDialog() {
    this.editFolder = false;
  }
  closeEditDialog() {
    this.editFolder = false;
    this.editedFolderEmit.emit(true);
  }

  savedForm(event: any) {
    this.data.name = event;
    this.closeEditDialog();
  }

  closeDialog() {
    this.selectFolder = false;
  }
  editImage(url: any) {
    this.EditImageEmit.emit(url);
  }
  savedProperties(event: any) {
    this.data.file_name = event.file_name;
    this.data.comment = event.comment;
    this.data.description = event.description;
    this.closePropertiesDialog();
  }
  deleteMedia() {
    if (this.data) {
      let media_ids: any[] = [];
      media_ids.push(this.data.id);
      this.confirmationService.confirm({
        message: this.translateService.instant('Are you sure you want to delete this?'),
        header: this.translateService.instant('Attention'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.store.dispatch(deleteMediaItemFromAlbum({ id: media_ids }));
          this.messageService.add({
            severity: 'info',
            summary: this.translateService.instant('Successful'),
            detail: this.translateService.instant('Your request has been successfully completed.'),
          });
          this.deletedIdEmit.emit(this.data.id);
        },
        key: 'deleteMediaDialogCard-' + this.data.id,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('Error'),
        detail: this.translateService.instant('No selected item found!'),
      });
    }
  }
  showFolders() {
    this.selectFolder = true;
  }
  editProperties(_data: any) {
    this.editProperty = true;
  }
  closePropertiesDialog() {
    this.editProperty = false;
  }
  openNewTab() {
    window.open(this.data.media_file_url, '_blank');
  }

  downloadFile() {
    const link = document.createElement('a');
    link.href = this.data.media_file_url;
    link.download = this.data.file_name + this.data.extension;
    link.target = '_blank';
    link.click();
  }

  iconNameSet(item: any) {
    let iconName = '';
    switch (true) {
      case item.type === 'media' && item.media_file_type === 'image':
        iconName = 'image';
        break;

      case item.type === 'media' && item.media_file_type === 'video':
        iconName = 'video';
        break;

      case item.type === 'media' && item.media_file_type === 'audio':
        iconName = 'volume-up';
        break;
      case item.type === 'media' && item.media_file_type === 'other':
        iconName = 'file';
        break;
      case item.type === 'media' && item.media_file_type === 'zip':
        iconName = 'file';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('doc'):
        iconName = 'file-word';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('xls'):
        iconName = 'file-excel';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('pdf'):
        iconName = 'file-pdf';
        break;
      case item.type === 'media' && item.media_file_type === 'document':
        iconName = 'file';
        break;
      case item.extension?.includes('application/zip'):
        iconName = 'zip';
        break;

      default:
        iconName = 'folder';
        break;
    }
    return iconName;
  }
}
